import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Orders } from "../Model/Orders";
import { OrderRepository } from "../Repository/OrderRepository";

export interface GetOrderstUseCase {
  invoke: (page: number, pageSize: number, orderCode: string, sortOrder: string, orderStatus: any, PaymentMethod: any, DeliveryMethod: any, fromDate: string, toDate: string, sortColumn: string) => Promise<PaginationResult<Orders>>;
}

export class GetOrders implements GetOrderstUseCase {
  private productRepo: OrderRepository;
  constructor(_ProductRepo: OrderRepository) {
    this.productRepo = _ProductRepo;
  }

   invoke(page: number, pageSize: number, orderCode: string, sortOrder: string, orderStatus: any, PaymentMethod: any, DeliveryMethod: any, fromDate: string, toDate: string, sortColumn: string){
    const getData = this.productRepo.getOrders(page, pageSize, orderCode, sortOrder, orderStatus, PaymentMethod, DeliveryMethod, fromDate, toDate, sortColumn);
    return getData;
  }
}